module.exports = __webpack_public_path__ + "img/mind_template_item_3_6.6e8730cc.png";